import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useAsyncCallback } from '@react-hooks-library/core';

import { setUserPermissions } from '@state-mgmt/slices/appSlice';

import { fetchUserPermissions } from '@services/user';
import { UserPermissionsResponsePayload } from '@mytypes/user';

export const useGetUserPermissions = () => {
  const dispatch = useDispatch();

  return useAsyncCallback(
    useCallback(async () => {
      try {
        const data = await fetchUserPermissions();
        dispatch(setUserPermissions(data));
        return data;
      } catch (error) {
        console.error('Error occurred fetching user permissions', error);
        dispatch(setUserPermissions(null));
        return { client: {}, trial: {} } as UserPermissionsResponsePayload;
      }
    }, [])
  );
};
